import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./context/auth";

function PrivateRoute({ component: Component, ...rest }) {
    // RIMOSSO PER ORA // const { authTokens } = useAuth();
    
    // recuperiamo direttamente da localstorage in attesa di riscrivere tutto Roobeek a hook
    const authToken = localStorage.getItem('token');

    return (
        <Route
            {...rest}
            render={props =>
                authToken ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/login" />
                )
            }
        />
    );
}

export default PrivateRoute;